import StationaryHeader from "./Header";
import "./index.css";
import { useState } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import FossilFuels from "./FossilFuels";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const StationaryComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="stationary-container" id="stationary-id">
      <StationaryHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Other Vehicle"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 2.6"}
            color={"#193666"}
          />
        </div>
      </div>

      {show && <FossilFuels businessId={businessId} />}
    </div>
  );
};

export default StationaryComponent;
